import Header from "../../header";
import Footer from "../../footer";
import BannerFooter from "./bannerForFooter";
import ContactForm from "../../contactcomponents/contactform";
import invertimage from '../../../images/footerLinksImages/productImage/investing.jpg';

function Investment() {

    const keywords = [
        { title: "Stock Market Basics", summary: "Learn the fundamentals of stock trading and investment strategies." },
        { title: "Cryptocurrency Insights", summary: "Understand the dynamics of crypto trading and blockchain technology." },
        { title: "Forex Trading Guide", summary: "Explore currency trading and risk management techniques." },
        { title: "Mutual Funds Investment", summary: "Discover the benefits and types of mutual fund investments." },
        { title: "Portfolio Management", summary: "Manage your investments with expert advice for optimized returns." },
        { title: "Technical Analysis", summary: "Analyze market trends using charts and technical indicators." },
        { title: "Derivatives Trading", summary: "Learn about options, futures, and hedging techniques." },
        { title: "Investment Planning", summary: "Plan your financial future with tailored investment strategies." },
        { title: "Risk Assessment", summary: "Evaluate and minimize risks to safeguard your investments." },
        { title: "Retirement Planning", summary: "Secure your financial future with long-term investment plans." },
      ];
    return (<>
        <Header />

        <BannerFooter
            title="Investment Solution"
            text="Our Investment Solutions provide a comprehensive guide to navigating the financial markets with confidence. From stock trading to cryptocurrency, we empower individuals with the tools and knowledge needed to maximize their returns and minimize risks. With expertly designed strategies in portfolio management, technical analysis, and long-term planning, we ensure every investment aligns with your financial goals. Whether you’re a seasoned trader or a beginner, our solutions are tailored to help you make informed decisions and achieve financial success"
            imageone={invertimage}
            imagetwo={invertimage}
        />

<div className="container-fluid py-5 bg-light">
      <div className="container p-4 shadow-lg bg-white rounded">
        <h2 className="text-center mb-4">Investment Solutions</h2>
        <div className="accordion" id="investmentAccordion">
          {keywords.map((item, index) => (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-header" id={`heading-${index}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse-${index}`}
                  style={{ transition: "all 0.3s ease" }}
                >
                  {item.title}
                </button>
              </h2>
              <div
                id={`collapse-${index}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading-${index}`}
                data-bs-parent="#investmentAccordion"
              >
                <div className="accordion-body">
                  {item.summary}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
        <ContactForm/>


        <Footer />
    </>)
}

export default Investment